module.exports = __webpack_public_path__ + "static/media/4_FR.fa37615a.mp3";